import Mood from "shared/lib/enums/Mood";
import apiAxios from "../../apiAxios";

export default async function setParticipantMood(
  participantId: number,
  mood: Mood
): Promise<void> {
  await apiAxios.put(`/participants/${participantId}/mood`, { mood });
}
